import type { PublicSlotKey } from '#packages/apilib';
import type { WorkspaceRightPanelApi } from './workspaceRightPanelApi';

export const WorkspaceRightPanelApiKey: PublicSlotKey<WorkspaceRightPanelApi> =
  {
    name: 'WorkspaceRightPanelApi',
    public: true,
  };
